import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { useAppSelector } from "../store/hooks";
import { makeStyles } from "@fluentui/react-components";

const useEmbedPowerBiStyles = makeStyles({
  powerBi: {
    "& iframe": {
      border: "none"
    },
    flexGrow: 1,
    height: "100%"
  }
});
const PowerBIReport = (props: any) => {
  let reportId = "";
  const styles = useEmbedPowerBiStyles();

  if (props.selectedItem?.row) {
    const reportLink = props.selectedItem.row.reportLink;
    const reportParser = reportLink?.split("/reports")[1];
    reportId = reportParser?.split("/")[1];
  }

  return (
    <PowerBIEmbed
      cssClassName={`${styles.powerBi}`}
      embedConfig={{
        type: "report", // Supported types: report, dashboard, tile, visual, qna, paginated report and create
        id: reportId,
        embedUrl: `https://msit.powerbi.com/reportEmbed?reportId=${reportId}`,
        accessToken: useAppSelector((state) => state.auth.powerbiToken),
        tokenType: 0, // Use models.TokenType.Aad for SaaS embed
        settings: {
          customLayout: {
            displayOption: models.DisplayOption.FitToPage
          }
        }
      }}
    />
  );
};

export default PowerBIReport;
